import axios from 'axios'
import Cookies from 'js-cookie'
import { i18n } from 'next-i18next'
import { removeToken } from 'src/core/helpers/auth'
import { isNotAuthRequest, isOtherAPI } from 'src/core/helpers'
axios.defaults.baseURL = process.env.NEXT_PUBLIC_API_URL
let pendingRequestCount = 0
axios.interceptors.request.use(function (config) {
  pendingRequestCount++
  if (config.url.includes('countries')) return config
  let userToken = Cookies.get(process.env.NEXT_PUBLIC_TOKEN_NAME)
  if (userToken) {
    if (!isOtherAPI(config.url)) {
      config.headers['Authorization'] = `JWT ${userToken}`
      config.headers['Accept-Language'] = i18n?.language
    }
  } else {
    if (isNotAuthRequest(config.url)) {
      window.location.href = `/accounts/auth/login`
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  pendingRequestCount--
  return response
}, function (error) {
  pendingRequestCount--
  const code = error?.response?.status
  if ([403, 401].includes(code)) {
    if (code === 403) { localStorage.removeItem('prevRoute') }
    removeToken() // to avoid issues with middleware
    window.location.href = `/accounts/auth/login`
  }
  return Promise.reject(error)
})
export { pendingRequestCount }
export default axios
